import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as supplierCategoryAction from './../../../../../actions/supplierCategoryAction';
import SupplierCategoryDetail from './CategoryDetail';

const mapStateToProps = state => {
    return {
        supplierCategoryState: state.supplierCategoryReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        setSupplierCategoryDetail: (category) => dispatch(supplierCategoryAction.setSupplierCategoryDetail(category)),
        createSupplierCategoryAction: (category) => dispatch(supplierCategoryAction.createSupplierCategoryAction(category)),
        getSupplierCategoryDetail: (id) => dispatch(supplierCategoryAction.getSupplierCategoryDetail(id)),
        updateSupplierCategoryAction: (category) => dispatch(supplierCategoryAction.updateSupplierCategoryAction(category)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(SupplierCategoryDetail));
